<script setup lang="ts">
import { ref } from 'vue';
import BtnIcon from '../BtnIcon/BtnIcon.vue';

defineProps<{
	fullSize?: boolean;
	title?: string;
	isFoldable?: boolean;
	stickyHeader?: boolean;
}>();

const isCardOpen = ref(true);
</script>

<template>
	<div :class="['info-card', { 'info-card--full-size': fullSize }]">
		<div
			v-if="title || $slots.header"
			:class="['info-card__header', { 'info-card__header--sticky': stickyHeader }]"
		>
			<slot name="header">
				<p class="heading-md">{{ title }}</p>
			</slot>
			<BtnIcon
				v-if="isFoldable"
				ariaLabel="Hide / show card body"
				title="Toggle card"
				:iconName="isCardOpen ? 'bx-chevron-up' : 'bx-chevron-down'"
				@click="() => (isCardOpen = !isCardOpen)"
			/>
		</div>
		<div :class="['info-card__body', { 'info-card__body--closed': !isCardOpen }]">
			<slot />
		</div>
	</div>
</template>

<style lang="scss" scoped>
.info-card {
	border-radius: $border-radius-2;
	background-color: white;
	box-shadow: $box-shadow-card;

	&--full-size {
		min-width: 100%;
	}

	&__body {
		height: fit-content;
		padding: $spacing-6;
		transition: all 200ms ease;

		&--closed {
			overflow: hidden;
			height: 0px;
			padding: 0;
			transition: all 200ms ease;
		}
	}

	&__header {
		top: 0;
		height: 48px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: $spacing-4;
		border-bottom: $border-width-1 $border-style $color-neutral-100;
		padding: $spacing-2 $spacing-6;

		&--sticky {
			position: sticky;
			top: 0;
			background-color: $color-white;
			z-index: $z-index-1;
		}
	}
}
</style>
